import {
	catchError
} from '@/js/util'
import {
	NewGetByKey,
	GetById
} from '@/js/urls'
export default {
	methods: {
		httpBack(promise, successBack, errorBack, msgObj) {
			promise.then((res) => {
				if (window.Panduanxx(res) == 'json') {
					if ('msg' in res) {
						if (res.msg == 'ok' || res.code == 'success') {
							successBack ? successBack(res) : false
							msgObj && msgObj.successMsg ? this.$message.success(msgObj.successMsg) : false
						} else {
							errorBack ? errorBack(res) : false
							msgObj && msgObj.errorMsg ? this.$message.error(msgObj.errorMsg) : false
							let message = (res.msg && res.msg !== 'error') ? res.msg : this.msgByCode(res.code)
							this.$message.error(message)
							return Promise.reject({
								message
							});
						}
					} else {
						if (res.Message == '发生错误。') {
							errorBack ? errorBack(res) : false
							msgObj && msgObj.errorMsg ? this.$message.error(msgObj.errorMsg) : false
							return Promise.reject({
								message: '登录异常！'
							});
						} else {
							successBack ? successBack(res) : false
							msgObj && msgObj.successMsg ? this.$message.success(msgObj.successMsg) : false
						}
					}
				} else {
					successBack ? successBack(res) : false
				}
			}).catch(catchError);
		},
		msgByCode(code) {
			let obj = {
				/// <summary>
				/// 成功
				/// </summary>
				success: '成功',
				/// <summary>
				/// 失败
				/// </summary>
				failure: '获取数据出错，请重新加载',
				/// <summary>
				/// 用户名或者密码错误
				/// </summary>
				usernameorpwderror: '用户名或者密码错误',
				/// <summary>
				/// 系统数据
				/// </summary>
				systemdata: '系统数据',
				/// <summary>
				/// 重复
				/// </summary>
				repeat: '重复',
				/// <summary>
				/// 数据重复
				/// </summary>
				data_repeat: '数据重复',
				/// <summary>
				/// 不存在
				/// </summary>
				notexist: '不存在',
				/// <summary>
				/// 存在子集
				/// </summary>
				existsubset: '存在子集',
				/// <summary>
				/// 无权限
				/// </summary>
				notAuthority: '无权限',
				/// <summary>
				/// 套餐到期
				/// </summary>
				packageMaturity: '套餐到期',
				/// <summary>
				/// 无访问url权限
				/// </summary>
				notAccessAuthority: '无访问url权限',
				/// <summary>
				/// 无访问数据权限
				/// </summary>
				notAccessDataAuthority: '无访问数据权限',
				/// <summary>
				/// 登录过期
				/// </summary>
				loginExpired: '登录过期',
				/// <summary>
				/// 登录失败
				/// </summary>
				loginFailure: '登录失败',
				/// <summary>
				/// 参数错误
				/// </summary>
				paramError: '参数错误',
				/// <summary>
				/// 部门名称重复
				/// </summary>
				deptname_exist: '部门名称重复',
				/// <summary>
				/// 身份证重复
				/// </summary>
				idcard_exist: '身份证重复',
				/// <summary>
				/// 文件柜或者文件夹重复
				/// </summary>
				// fileCabinet_exist: '文件柜或者文件夹重复',
				/// <summary>
				/// 主表信息不完整
				/// </summary>
				nofull: '主表信息不完整',
				/// <summary>
				/// 部门下有员工信息
				/// </summary>
				depthaveemp: '部门下有员工信息',
				/// <summary>
				/// 部门包含子部门
				/// </summary>
				depthavechilddept: '部门包含子部门',
				/// <summary>
				/// 人员下包含证书
				/// </summary>
				emphavecer: '人员下包含证书',
				/// <summary>
				/// 菜单包含子菜单
				/// </summary>
				menuhavechildmenu: '菜单包含子菜单',
				/// <summary>
				/// 角色下包含有用户
				/// </summary>
				rolehaveuser: '角色下包含有用户',
				/// <summary>
				/// 未知错误
				/// </summary>
				unknown: '未知错误',
				/// <summary>
				/// 文件过大
				/// </summary>
				oversize: '文件过大',
				/// <summary>
				/// 未传入数据
				/// </summary>
				noIncomingData: '未传入数据',
				/// <summary>
				/// 不存在此用户
				/// </summary>
				NonExistentUser: '不存在此用户',
				/// <summary>
				/// 短信验证错误
				/// </summary>
				MessageCodeError: '短信验证错误'
			}
			return obj[code]
		},
		/**
		 * 新增tab即新页面的操作
		 */
		openNewTab(param, data, tag) {
			let exp1 = /编辑$/
			let exp2 = /添加$/
			let exp3 = /详情$/
			console.log(param)
			let title = param.title || param.menu_name
			let name = param.url || param.name
			let key = name.replace('Edit', '').replace('Detail', '').replace('Add', '')
			if (exp1.test(title) || exp2.test(title) || exp3.test(title)) {
				if (this.$store.state.common.allPath[key]) {
					title = this.$store.state.common.allPath[key].menu_name + '-' + title
				}
			}
			tag = tag ? (param.url + tag) : name
			let obj = {
				tag,
				name,
				label: title,
				content: title,
				param: data ? data : param,
				menu_id: param.menu_id ? param.menu_id : null,
			}
			console.log(obj, 'mmm')
			// console.log(this.$router.history)
			this.$router.history.current.meta.keepAlive = true
			//如果页面已经打开
			if (tag in this.$store.state.common.tabObjs) {
				this.$store.dispatch('changeTopTab', obj);
			} else { //如果没打开，则新增
				this.$store.dispatch('addTopTab', obj)
			}
			this.$router.replace({
				name,
				params: data ? data : param,
			})
		},
		//根据基础数据请求
		getByKey(str, callback) {
			if (str) {
				this.httpBack(NewGetByKey({
					key: str
				}), (res) => {
					callback(res)
				})
			}
		},
		//根据id请求基础数据
		getById(str, callback) {
			if (str) {
				this.httpBack(GetById({
					id: str
				}), (res) => {
					callback(res)
				})
			}
		},
		//确认提示框
		iConfirm(title, subtitle, callback, errorback) {
			this.$confirm(subtitle, title, {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				callback ? callback(true) : false
			}).catch(() => {
				errorback ? errorback(false) : false
				this.$message({
					type: 'info',
					message: '点击取消'
				});
			});
		},
		//输入框弹框
		iPrompt(title, subtitle, callback, errorback) {
			this.$prompt(subtitle, title, {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			}).then(({
				value
			}) => {
				callback ? callback(value) : false
			}).catch(() => {
				errorback ? errorback(false) : false
				this.$message({
					type: 'info',
					message: '取消输入'
				});
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/js/mixins.js